module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-page-wrapper feed-back-page-wrapper",
    class: {
      'bodyfont-unauth': !_vm.user
    }
  }, [_c('div', {
    staticClass: "over-lay"
  }), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "main-content"
  }, [_c('h2', {
    style: ({
      color: _vm.getCorpHeadingColor
    })
  }, [_vm._v("Feedback")]), _vm._v(" "), _c('p', [_vm._v("We’d love to hear from you.")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-md-offset-2"
  }, [_c('div', {
    staticClass: "form"
  }, [_c('form', {
    attrs: {
      "id": "fb_form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 padding-minus"
  }, [(!_vm.user) ? _c('div', [_c('bs-input', {
    staticClass: "form-input",
    attrs: {
      "id": "feedback_name",
      "type": "text",
      "error": "Name",
      "placeholder": "Name",
      "required": ""
    },
    model: {
      value: (_vm.feedbackForm.name),
      callback: function($$v) {
        _vm.$set(_vm.feedbackForm, "name", $$v)
      },
      expression: "feedbackForm.name"
    }
  }), _vm._v(" "), _c('bs-input', {
    staticClass: "form-input",
    attrs: {
      "id": "feedback_email",
      "type": "email",
      "error": "Email Address",
      "placeholder": "Email Address",
      "required": ""
    },
    model: {
      value: (_vm.feedbackForm.email),
      callback: function($$v) {
        _vm.$set(_vm.feedbackForm, "email", $$v)
      },
      expression: "feedbackForm.email"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('bs-input', {
    staticClass: "form-input",
    attrs: {
      "id": "feedback_comments",
      "type": "textarea",
      "error": "Comments",
      "placeholder": "Comments",
      "required": ""
    },
    model: {
      value: (_vm.feedbackForm.comments),
      callback: function($$v) {
        _vm.$set(_vm.feedbackForm, "comments", $$v)
      },
      expression: "feedbackForm.comments"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center"
  }, [(!_vm.spinner) ? _c('button', {
    staticClass: "btn formButton btn-transparent",
    style: ({
      color: _vm.getCorpButtonColor,
      borderWidth: '1px !important',
      borderStyle: 'solid !important',
      borderColor: this.getCorpButtonColor + ' !important'
    }),
    attrs: {
      "id": "feedback_submit"
    }
  }, [_vm._v("\n                                Send\n                                "), (_vm.spinner) ? _c('spinner', {
    staticClass: "btn-spinner",
    attrs: {
      "size": "lg"
    },
    model: {
      value: (_vm.spinner),
      callback: function($$v) {
        _vm.spinner = $$v
      },
      expression: "spinner"
    }
  }) : _vm._e()], 1) : _vm._e()])]), _vm._v(" "), _c('alert', {
    attrs: {
      "placement": "top-right",
      "duration": "2000",
      "type": "danger",
      "width": "400px",
      "dismissable": ""
    },
    model: {
      value: (_vm.error.show),
      callback: function($$v) {
        _vm.$set(_vm.error, "show", $$v)
      },
      expression: "error.show"
    }
  }, [_c('span', {
    staticClass: "icon-info-circled alert-icon-float-left"
  }), _vm._v(" "), _c('strong', [_vm._v("Error:")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "contactus_errormsg"
    }
  }, [_vm._v(_vm._s(_vm.error.message))])])], 1)])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1a23b194", module.exports)
  }
}


// WEBPACK FOOTER //
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1a23b194"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"search":"pk_test_6pRNASCoBOKtIshFeQd4XMUh","replace":"pk_test_SLHUyTkZmNS1OnLNdclgNldo"}!./~/string-replace-loader?{"search":"https:/www1.dev-tonenetworks.com","replace":"https:/www1.dev-tonenetworks.com"}!./~/string-replace-loader?{"search":"https:/s3.amazonaws.com/tone-assets/app/navigation","replace":"https:/s3.amazonaws.com/tone-assets/app/navigation"}!./~/string-replace-loader?{"search":"sandbox_2yn8x45w_k2v4j3d55x4gh6xz","replace":"production_6r7mxqgh_htw3nq9wp32w8h2x"}!./src/components/Feedback.vue